import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Button from '../../Button.js';
import CaseBillingModal from './CaseBillingModal.js';
const CaseBilling = (props) => {
    const lang = useSelector((s) => s.lang);
    const [modalOpen, setModalOpen] = useState(false);
    return (React.createElement("p", { style: { margin: 0 } },
        React.createElement(Button, { theme: "link", onClick: () => setModalOpen(!modalOpen) }, lang.clientBilling.seeDetails),
        modalOpen && (React.createElement(CaseBillingModal, { onToggle: () => setModalOpen(!modalOpen), caseId: props.caseId, tenantId: props.tenantId, creditorId: props.creditorId, currency: props.currency }))));
};
export default CaseBilling;
//# sourceMappingURL=CaseBilling.js.map